import { render, staticRenderFns } from "./r-item-group-dropdown.vue?vue&type=template&id=59205c0f"
import script from "./r-item-group-dropdown.vue?vue&type=script&lang=js"
export * from "./r-item-group-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59205c0f')) {
      api.createRecord('59205c0f', component.options)
    } else {
      api.reload('59205c0f', component.options)
    }
    module.hot.accept("./r-item-group-dropdown.vue?vue&type=template&id=59205c0f", function () {
      api.rerender('59205c0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item-group/r-item-group-dropdown.vue"
export default component.exports